import { RouteConfig } from 'vue-router';
import AvailableServices from './components/available-services.vue';

export const availableServices: RouteConfig = {
  path: 'available-services',
  component: AvailableServices,
};
